import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { EDUCATION_LEVEL_VALUES, TRAINING_LEVEL, LEARN_MORE_LINK } from '../../utils/constants';

const ProfileHighlightsSection = ({ profile }) => {

  const hasValidEducationField = () => {
    return profile.education
      && profile.education
      !== EDUCATION_LEVEL_VALUES.NOT_DISCLOSED;
  };

  const hasValidTrainingField = () => {

    return profile.accreditations && !profile?.accreditations.includes(TRAINING_LEVEL.NOT_DISCLOSED) && !profile.accreditations?.includes(TRAINING_LEVEL.NOT_APPLICABLE);
  };

  const includeEducation = hasValidEducationField();
  const includeTraining = hasValidTrainingField();
  const includeCertifications = !!profile.certifications;
  const includeSkills = profile.selectedSkills?.length > 0;
  const includeLanguages = profile.languages?.length > 0;
  let sectionCount = 0;
  if (includeEducation) {
    sectionCount += 1;
  }
  if (includeTraining) {
    sectionCount += 1;
  }
  if (includeCertifications) {
    sectionCount += 1;
  }
  if (includeSkills) {
    sectionCount += 1;
  }
  if (includeLanguages) {
    sectionCount += 1;
  }

  const smSize = 12 / sectionCount;

  if (!sectionCount) {
    return null;
  }

  const renderLinkOrText = () => {
    if (profile.accreditations?.includes(TRAINING_LEVEL.BOOTCAMP)) {
      return (
        <a
          className="link-blue"
          target="_blank"
          rel="noopener noreferrer"
          href={LEARN_MORE_LINK}
        >
          {TRAINING_LEVEL.BOOTCAMP}
        </a>
      );
    }
    return Array.isArray(profile.accreditations) ? profile.accreditations?.join(', ') : '';
  };

  const renderEducationAndTraining = () => {
    if (includeEducation || includeTraining) {
      return (
        <Col sm={smSize} xs={6} fallback={12}>
          <h2>Education & Training</h2>
          <ul>
            {
              includeEducation && (
                <li role="text">
                  {profile.education}
                </li>
              )
            }
            {
              includeTraining && (
                <li role="text">
                  {renderLinkOrText()}
                </li>
              )
            }
          </ul>
        </Col>
      );
    }
  };

  const renderCertifications = () => {
    if (includeCertifications) {
      return (
        <Col sm={smSize} xs={6} fallback={12}>
          <h2>Additional Certifications</h2>
          <p className="pre-formatted">{profile.certifications}</p>
        </Col>
      );
    }
  };

  const generateListItem = (listItemData) => {
    return listItemData.map((it, i) => (
      <li role="text" key={i}>
        {it}
      </li>
    ));
  };

  const renderSkills = () => {
    if (includeSkills) {
      return (
        <Col sm={smSize} xs={6} fallback={12}>
          <h2>Skills & Areas of Expertise</h2>
          <ul>
            { generateListItem(profile.selectedSkills) }
          </ul>
        </Col>
      );
    }
  };

  const renderLanguages = () => {
    if (includeLanguages) {
      return (
        <Col sm={smSize} xs={6} fallback={12}>
          <h2>Languages</h2>
          <ul>
            { generateListItem(profile.languages) }
          </ul>
        </Col>
      );
    }
  };

  return (
    <Row className="p2p-profile__section">
      <Col className="p2p-profile__highlights">
        {renderSkills()}
        {renderCertifications()}
        {renderEducationAndTraining()}
        {renderLanguages()}
      </Col>
    </Row>
  );
};

export default ProfileHighlightsSection;

ProfileHighlightsSection.propTypes = {
  profile: PropTypes.shape({
    education: PropTypes.string,
    accreditations: PropTypes.arrayOf(PropTypes.string),
    certifications: PropTypes.string,
    selectedSkills: PropTypes.arrayOf(PropTypes.string),
    languages: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};
